import { createLogic } from 'redux-logic'
import handleErrors from '@app/helpers/handleErrors'
import { RESET_TIMER } from '@app/constants/timers/timers'
import Api from '@app/api/timers/resetTimer'
import { API_REQUEST_CANCEL } from '@app/constants/apiRequest'
import { apiRequestSent, apiRequestDone, apiRequestFailed } from '@app/actions/apiRequest'

const resetTimerLogic = createLogic({
  type: RESET_TIMER,
  latest: true,
  cancelType: API_REQUEST_CANCEL,

  transform({ getState, action }, next) {
    const { secrets: { accessToken: { token: accessToken } } } = getState()
    const { timers: { timerData } } = getState()
    next({
      ...action,
      accessToken,
      timerData,
    })
  },

  process({ action }, dispatch, done) {
    dispatch(apiRequestSent(RESET_TIMER))
    Api.resetTimer(action.accessToken, action.timerData.number)
      .then(() => {
        dispatch(apiRequestDone(RESET_TIMER))
      })
      .catch((error) => {
        if (error) {
          const currentError = handleErrors(error)
          dispatch(apiRequestFailed(currentError))
        } else {
          throw new Error('resetTimer failed without error')
        }
      })
      .then(() => done())
  },
})

export default resetTimerLogic
